<template>
  <div class="real-shrine-layout">
    <div id="toggleMysticFogDiv">
      <p id="mysticP">Mystic Fog</p>

      <div id="switchDiv">
        <span id="offSpan">OFF</span>
        <v-switch id="stakeVswitch" v-model="isVantaFog" inset @click="toggleBackground()"></v-switch>
        <span id="onSpan">ON</span>
      </div>
    </div>

    <div class="tabs">
      <div class="left" :class="activeTab === 'my_gurus' ? 'active' : ''" @click="changeTab('my_gurus')">
        <p id="myGurusP">My Gurus</p>
      </div>
      <div class="middle" :class="activeTab === 'my_aura' ? 'active' : ''" @click="changeTab('my_aura')">
        <p id="myAuraP">Merchant</p>
      </div>
      <div class="right" :class="activeTab === 'container' ? 'active' : ''" @click="changeTab('container')">
        <p id="containerP">Mystic Vessels</p>
      </div>
    </div>

    <div class="contents">
      <MyGurus v-if="activeTab === 'my_gurus'" />
      <MyAura v-if="activeTab === 'my_aura'" />
      <Container v-if="activeTab === 'container'" />
    </div>
  </div>
</template>

<script>
  import MyGurus from '../components/MyGurus';
  import MyAura from '../components/MyAura';
  import Container from '../components/Container';

  const RealShrineConstants = require('../constants/realShrine');

  export default {
    name: 'RealShrineLayout',
    components: {
      MyGurus,
      MyAura,
      Container
    },
    data: () => ({
      activeTab: 'my_gurus',
      RealShrineConstants: RealShrineConstants,
      isVantaFog: false,
      vantaFog: undefined,
      // WordPress bind data. eros god
      wpData: wpData,
    }),
    mounted() {
      if (localStorage.getItem('isVantaFog') == null || localStorage.getItem('isVantaFog') == undefined) {
        localStorage.setItem('isVantaFog', false);
      }

      if (localStorage.getItem('isVantaFog') == 'true') {
        this.isVantaFog = true;
      } else if (localStorage.getItem('isVantaFog') == 'false') {
        this.isVantaFog = false;
      }

      if (this.isVantaFog) {
        this.vantaFog = VANTA.FOG({
          el: ".real-shrine-layout",
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          highlightColor: parseInt(wpData.VANTA_FOG_HIGHLIGHTCOLOR, 16),
          midtoneColor: parseInt(wpData.VANTA_FOG_MIDTONECOLOR, 16),
          lowlightColor: parseInt(wpData.VANTA_FOG_LOWLIGHTCOLOR, 16),
          baseColor: parseInt(wpData.VANTA_FOG_BASECOLOR, 16),
          blurFactor: parseFloat(wpData.VANTA_FOG_BLURFACTOR),
          speed: parseInt(wpData.VANTA_FOG_SPEED),
          zoom: parseInt(wpData.VANTA_FOG_ZOOM)
        });
      }

      if (localStorage.getItem('activeTab') === null || localStorage.getItem('activeTab') === undefined) {
        localStorage.setItem('activeTab', 'my_gurus');
      }

      if (localStorage.getItem('activeTab') === 'my_gurus') {
        this.activeTab = 'my_gurus';
      } else if (localStorage.getItem('activeTab') === 'my_aura') {
        this.activeTab = 'my_aura';
      } else {
        this.activeTab = 'container';
      }
    },
    methods: {
      changeTab(pTab) {
        this.activeTab = pTab;

        localStorage.setItem('activeTab', pTab);
      },
      toggleBackground() {
        localStorage.setItem('isVantaFog', this.isVantaFog);

        if (this.isVantaFog) {
          this.vantaFog = VANTA.FOG({
            el: ".real-shrine-layout",
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            highlightColor: parseInt(wpData.VANTA_FOG_HIGHLIGHTCOLOR, 16),
            midtoneColor: parseInt(wpData.VANTA_FOG_MIDTONECOLOR, 16),
            lowlightColor: parseInt(wpData.VANTA_FOG_LOWLIGHTCOLOR, 16),
            baseColor: parseInt(wpData.VANTA_FOG_BASECOLOR, 16),
            blurFactor: parseFloat(wpData.VANTA_FOG_BLURFACTOR),
            speed: parseInt(wpData.VANTA_FOG_SPEED),
            zoom: parseInt(wpData.VANTA_FOG_ZOOM)
          });
        } else {
          if (this.vantaFog != undefined) {
            this.vantaFog.destroy();  
          }
        }
      }
    },
    computed: {
    },
  };
</script>

<style scoped>
  .real-shrine-layout {
    min-height: 100vh;
    background-color: transparent;
    background-image: radial-gradient(at center center, #FFF589 0%, #782B3E 100%);
  }

  p {
    margin: 0px;
  }

  .tabs {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }

  .tabs .active {
    background-color: #13aff0;
  }

  .tabs .left, .tabs .middle, .tabs .right {
    padding: 15px 30px;
    color: #fff;
    font-weight: 600;
    font-family: Architects Daughter;
    cursor: pointer;
  }

  .contents {
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin: 10px 100px;
    padding: 20px 50px;
  }

  #toggleMysticFogDiv {
    position: absolute;
    left: 130px;
    top: 5px;
    z-index: 100;
  }

  #toggleMysticFogDiv #mysticP {
    color: #FFFFFF;
    letter-spacing: 1.8px;
    text-shadow: 0px 0px 4px #fffeab;
    font-family: Architects Daughter;
    font-size: 20px;
    text-align: center;
  }

  #toggleMysticFogDiv #switchDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -15px;
  }

  #toggleMysticFogDiv #switchDiv #offSpan, #toggleMysticFogDiv #switchDiv #onSpan {
    color: #FFFFFF;
    letter-spacing: 1.8px;
    text-shadow: 0px 0px 4px #fffeab;
    font-family: Architects Daughter;
    font-size: 20px;
  }

  #toggleMysticFogDiv #switchDiv #offSpan {
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/RealShrineLayout.vue